/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useContext} from 'react';
import {useRouteMatch, useHistory} from 'react-router-dom';
import {FluidContainer, SimpleTabs, TableAccExamsPlayer, TableTrainingPlayer} from '../../../components';
import {ARMcontext} from '../../../utils/context/context';
import {Teams} from '../../../utils/api';
import {RadiosContainer, TableWrapper, RadiosWrapper} from '../styles';
import { Loader } from '../../../components';

const TableDefaultTabs = [
  {
    title: 'TRAINING',
    url: 'training',
    icon: '',
    action: () => {},
  },
  {
    title: 'EXAMS',
    url: 'exams',
    icon: '',
    action: () => {},
  },
];

export default ({playersGroup, playerNameSearch}: {playersGroup: string; playerNameSearch: string}) => {
  const [exams, useExams] = useState<Array<object | any>>([]);
  const {selectedPlayer} = useContext(ARMcontext);
  const {selectedTeam} = useContext(ARMcontext);
  const [loadingTable, setLoadingTable] = useState(true);
  const TEAMS = new Teams();
  const history = useHistory();
  const {url} = useRouteMatch();
  useEffect(() => {
    getAccountabilityExams(selectedPlayer);
  }, [playersGroup, selectedTeam, playerNameSearch, selectedPlayer]);
  async function getAccountabilityExams(selectedPlayer) {
 
    const examsResponse = await TEAMS.GetPlayerAccountabilityExams(selectedPlayer._id,true);
    //const examsResponse = await TEAMS.GetAccountabilityExams(selectedTeam._id, playersGroup, playerNameSearch);
    //const player = examsResponse.data.records.filter(x => x._id === selectedPlayer._id)
    useExams(examsResponse);
     setLoadingTable(false);
    // if (examsResponse.status) {
    //     useExams(player);
    //     setLoadingTable(false);
    //   }
  }
  useEffect(() => {
    //history.push('/players/accountability/training');
  }, [history]);
  return (
    <FluidContainer>
      <RadiosWrapper alignItems='center'>
        <RadiosContainer data-cy="accountability-navigation">
          <SimpleTabs dataArray={TableDefaultTabs} url={url} />
        </RadiosContainer>
      </RadiosWrapper>
      <TableWrapper>
      {loadingTable ?
            <div style={{ width: '100%', display: 'block', alignItems: 'center' }}>
              <Loader height="90px" />
            </div> :
            <>
                    {window.location.href.includes('/accountability/exams') && <TableAccExamsPlayer dataTableContent={exams} />}
                    {window.location.href.includes('/accountability/training') && <TableTrainingPlayer dataTableContent={exams} />}
                    </>
            }

      </TableWrapper>
    </FluidContainer>
  );
};
